export default "__VITE_ASSET___0Sw8__H__"